import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { DocumentPublic } from "../v1/DocumentPublic";
import { MrfiktivDocumentViewModelGen } from "../v1/data-contracts";

class DocumentService {
  private proxy: DocumentPublic;

  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new DocumentPublic(mrfiktivHttpClientProvider.client());
  }

  async createPublic(partnerId: string, file: File): Promise<MrfiktivDocumentViewModelGen> {
    const response = await this.proxy.documentPublicControllerCreatePublic(partnerId, { file });
    return response.data;
  }
}

export default new DocumentService(new MrfiktivHttpClientProvider());
